<div class="log-modal-container">
  <div class="sub-title title-header">{{this.data.subtitle}}</div>
  <div mat-dialog-title class="title-header">
    {{ this.data.title }}
  </div>
  <div mat-dialog-content class="content-container">
    @if (loading) {
      <div class="row" style="justify-content: center">
        <div style="max-width: 45px; overflow: hidden"><mat-spinner [diameter]="30"></mat-spinner></div>
      </div>
    }
    @if (logs.length == 0 && !loading) {
      <div class="row" style="justify-content: center">
        No history available
      </div>
    }
    @if (logs.length > 0 && !loading) {
      @for (role of history | keyvalue; track role) {
        <div class="table-header">{{role.key}}</div>
        <table mat-table class="stripped-table mat-elevation-z4" [dataSource]="$any(role).value">
          <ng-container matColumnDef = "status">
            <th mat-header-cell *matHeaderCellDef>Status</th>
            <td mat-cell *matCellDef="let row">
              @if (row.projectInstallmentFundingConditionApprovalStatus!==null) {
                {{row.projectInstallmentFundingConditionApprovalStatus.name}}
              }
              @if (row.projectInstallmentFundingConditionApprovalStatus==null) {
                --
              }
            </td>
          </ng-container>
          <ng-container matColumnDef = "user">
            <th mat-header-cell *matHeaderCellDef>User</th>
            <td mat-cell *matCellDef="let row">{{ row.user !== null ? row.user.person?.name : "--" }}</td>
          </ng-container>
          <ng-container matColumnDef = "date">
            <th mat-header-cell *matHeaderCellDef>Date</th>
            <td mat-cell *matCellDef="let row">{{ row.approval_status_date}}</td>
          </ng-container>
          <tr mat-header-row *matHeaderRowDef="['status', 'user', 'date']"></tr>
          <tr mat-row *matRowDef="let row; columns: ['status', 'user', 'date']"></tr>
        </table>
      }
    }
  </div>
  <div mat-dialog-actions class="action-buttons">
    <button mat-button class="close-button" (click)="close()">Close</button>
  </div>
</div>
